import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { Box, CircularProgress, Grid, IconButton, Paper, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { DetailRow } from '../components/DetailRow';
import { DetailRowLink } from '../components/DetailRowLink';
import { TransactionTable } from '../components/TransactionTable';
import { Rendicontazione } from '../interface/rendicontazione';
import { fetchRendicontazione, fetchTransactionData } from '../api/rendicontazioni';
import { useAuth } from '../components/auth/AuthProvider';
import { Navbar } from '../components/Navbar';
import { ErrorContent } from '../components/ErrorContent';

export const EventDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { token, logout } = useAuth();

  const {
    data: event,
    isLoading: isLoadingEvent,
    error: eventError,
  } = useQuery<Rendicontazione>('rendicontazione', async () => fetchRendicontazione(token, id!));

  const {
    data: transactionData,
    isLoading: isLoadingTransactions,
    error: transactionError,
  } = useQuery(['transactions', id], () => fetchTransactionData(token, id!), {
    enabled: !!id,
  });

  const isLoading = isLoadingEvent || isLoadingTransactions;
  const error = eventError || transactionError;

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (error || !event) {
    return (
      <>
        <Navbar onLogout={logout} />
        <Box p={3}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h5" component="h1">
              Dettaglio Evento
            </Typography>
          </Box>
          <ErrorContent />
        </Box>
      </>
    );
  }

  return (
    <>
      <Navbar onLogout={logout} />
      <Box p={3}>
        <Box display="flex" alignItems="center" mb={3}>
          <IconButton onClick={() => navigate('/')} sx={{ mr: 2 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h5" component="h1">
            Dettaglio Evento {event.id_evento}
          </Typography>
        </Box>

        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <DetailRow label="Username Volontario" value={event.username_volontario} />
              <DetailRow label="Provincia" value={event.provincia} />
              <DetailRow label="Comune" value={event.comune} />
              <DetailRowLink
                label="Evento Photo Gallery"
                value={event.evento_foto_gallery}
                linkTo={`/eventi-foto/${event.id_evento}`}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DetailRow label="Nome Piazza" value={event.nome_piazza} />
              <DetailRow label="Nome Responsabile" value={event.nome_responsabile} />
              <DetailRow label="Evento Chiuso" value={event.sent ? 'Sì' : 'No'} />
            </Grid>
          </Grid>
        </Paper>

        {transactionData && <TransactionTable data={transactionData} />}
      </Box>
    </>
  );
};
